import { getCalendarEventComposeDeepLinkUrl, getCalendarEventReadDeepLinkUrl } from 'owa-url';

export default function getCalendarDeepLinkUrl(itemId: string, isCompose: boolean): string {
    if (isCompose) {
        return getCalendarEventComposeDeepLinkUrl(itemId);
    } else {
        return getCalendarEventReadDeepLinkUrl(itemId);
    }
}
